import { FormulationAttributesOption } from './types';

export const formulationTypeOptions: FormulationAttributesOption[] = [
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:owEmulsion',
    value: 'o-w-emulsion',
    applications: {
      '*|PersonalCare': [
        'A_PC_012', // Baby Care
        'A_PC_012_001', // Baby Care / Baby Care
        'A_PC_005', // Color Cosmetics
        'A_PC_005_006', // Foundation
        'A_PC_005_007', // Make-up Remover
        'A_PC_009', // Deodorants / Antiperspirants
        'A_PC_009_001', // Deodorants / Antiperspirants
        'A_PC_001', // Hair
        'A_PC_001_002', // Conditioning
        'A_PC_001_004', // Treatment
        'A_PC_001_005', // Scalp
        'A_PC_001_006', // Beard
        'A_PC_008', // Hair Removal
        'A_PC_008_001', // Shaving
        'A_PC_008_002', // Depilatory
        'A_PC_013', // Hygiene
        'A_PC_013_001', // Hygiene
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun
        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:woEmulsion',
    value: 'w-o-emulsion',
    applications: {
      '*|PersonalCare': [
        'A_PC_012', // Baby Care
        'A_PC_012_001', // Baby Care / Baby Care
        'A_PC_005', // Color Cosmetics
        'A_PC_005_006', // Foundation
        'A_PC_005_007', // Make-up Remover
        'A_PC_001', // Hair
        'A_PC_001_002', // Conditioning
        'A_PC_001_006', // Beard
        'A_PC_001_007', // Bleaching
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:waterBased',
    value: 'water-based',
    applications: {
      '*|PersonalCare': [
        'A_PC_006',
        'A_PC_006_001',
        'A_PC_006_002',
        'A_PC_006_003',
        'A_PC_006_004',
        'A_PC_006_005',
        'A_PC_006_006',
        'A_PC_012', // Baby Care
        'A_PC_012_001', // Baby Care / Baby Care
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_005', // Nail
        'A_PC_005_006', // Foundation
        'A_PC_005_007', // Make-up Remover
        'A_PC_009', // Deodorants / Antiperspirants
        'A_PC_009_001', // Deodorants / Antiperspirants
        'A_PC_001', // Hair
        'A_PC_001_001', // Cleansing
        'A_PC_001_002', // Conditioning
        'A_PC_001_003', // Dry shampoo
        'A_PC_001_004', // Treatment
        'A_PC_001_005', // Scalp
        'A_PC_001_006', // Beard
        'A_PC_008', // Hair Removal
        'A_PC_008_001', // Shaving
        'A_PC_008_002', // Depilatory
        'A_PC_013', // Hygiene
        'A_PC_013_001', // Hygiene
        'A_PC_004', // Oral
        'A_PC_004_002', // Mouthwash
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun
        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:oilBased',
    value: 'oil-based',
    applications: {
      '*|PersonalCare': [
        'A_PC_006',
        'A_PC_006_001',
        'A_PC_006_002',
        'A_PC_006_003',
        'A_PC_006_005',
        'A_PC_006_006',
        'A_PC_012', // Baby Care
        'A_PC_012_001', // Baby Care / Baby Care
        'A_PC_005', // Color Cosmetics
        'A_PC_005_001', // Lip
        'A_PC_005_003', // Pencils
        'A_PC_005_004', // Eye
        'A_PC_005_006', // Foundation
        'A_PC_005_007', // Make-up Remover
        'A_PC_001', // Hair
        'A_PC_001_004', // Treatment
        'A_PC_001_005', // Scalp
        'A_PC_001_006', // Beard
        'A_PC_008', // Hair Removal
        'A_PC_008_001', // Shaving
        'A_PC_008_002', // Depilatory
        'A_PC_013', // Hygiene
        'A_PC_013_001', // Hygiene
        'A_PC_003', // Skin Care
        'A_PC_003_001', // Eye
        'A_PC_003_002', // Face
        'A_PC_003_003', // Body
        'A_PC_003_004', // Foot
        'A_PC_003_005', // Hand
        'A_PC_003_006', // Lip
        'A_PC_003_007', // Facial Cleanser
        'A_PC_002', // Styling
        'A_PC_002_001', // Non-aerosol
        'A_PC_007', // Sun Care
        'A_PC_007_001', // Sun Care
        'A_PC_007_002', // Self Tan
        'A_PC_007_003', // After Sun
        'A_PC_011', // Wipes
        'A_PC_011_001', // Wipes
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:emulsion',
    value: 'emulsion',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:anhydrous',
    value: 'anhydrous',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:alcoholic',
    value: 'alcoholic',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:nonAlcoholic',
    value: 'non-alcoholic',
    applications: {
      '*|PersonalCare': [
        'A_PC_010', // Fragrance
        'A_PC_010_001', // Fragrance
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:solidStick',
    value: 'solid-stick',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:gelStick',
    value: 'gel-stick',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:nonAerosolSpray',
    value: 'non-aerosol-spray',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:cream',
    value: 'cream',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:rollOn',
    value: 'roll-on',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
  {
    name:
      'topics:formulation-attributes:options:availableFormulationTypes:powder',
    value: 'powder',
    applications: {
      '*|PersonalCare': [
        'A_PC_016', // AP/Deo
      ],
    },
  },
];
